<template>
  <div>
    <div class="row">
      <div :class="['col_12', {'loading_overlay': loading}]">
        <div class="card no_border">
          <div class="card-header">
            <div class="card-title">{{ title }}</div>
          </div>
          <div class="card-body pl_0 pr_0">
            <div class="row">
              <div class="col_12">
                <div :class="['form-group', {'has_error': errorFor('point')}]">
                  <label>{{ $t('sidebar.point.point') }}</label>
                  <input type="number" v-model="form.point" class="form_global" min="1">
                  <v-errors :errors="errorFor('point')" />
                </div>
              </div>
            </div>
            <div class="d_flex_end form_action_btn">
              <router-link class="btn btn_danger ml_10" :to="{name: cancelRouteName}">{{ $t('common.cancel') }}</router-link>
              <button class="btn btn_blue ml_10" @click.prevent="submit">{{ $t('common.save') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: this.$t('sidebar.point.add_point'),
      cancelRouteName: 'settings_point',
      form: {
        point: '',
      }
    }
  },
  created() {
    if (this.$route.name === 'settings_point_edit') {
      this.axios.get('/points/'+this.$route.params.id)
        .then((response) => {
          this.form = response.data.data;
          delete this.form.id;
        })
      this.title = this.$t('sidebar.point.edit_point');
    }
  },
  methods: {
    submit() {
      this.allErrors = null;
      this.loading = true;

      if (this.$route.name === 'settings_point_edit') {
        this.axios.patch('/points/'+this.$route.params.id, this.form)
          .then(() => {
            this.$router.push({name: 'settings_point'});
            this.showSuccessMsg(this.$t('common.updateSuccess'))
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.axios.post('/points', this.form)
          .then(() => {
            this.$router.push({name: 'settings_point'});
            this.showSuccessMsg(this.$t('common.addSuccess'))
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }
}
</script>
